"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("./Button");
var _Icon = require("../Icon");
var _styles = require("../../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var ButtonDropdown = function ButtonDropdown(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    type = _ref.type,
    size = _ref.size,
    disabled = _ref.disabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.Button, {
    onClick: onClick,
    size: size,
    type: type,
    disabled: disabled,
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'chevronDown',
      size: _styles.iconSizes.atom[size]
    })]
  });
};
exports.ButtonDropdown = ButtonDropdown;
ButtonDropdown.defaultProps = {
  type: 'pink',
  size: 'm',
  disabled: false
};